export default function WarrantySerialCheck() {
	const field = document.querySelector('.js-warranty-serial input');
	const wrapper = field?.closest('.gfield');

	if (!field || !wrapper) {
		return;
	}

	// Rendered with GF's own validation message classes so the live message
	// looks identical to the submit-time one.
	const message = document.createElement('div');
	message.className = 'gfield_description validation_message gfield_validation_message';
	message.setAttribute('aria-live', 'polite');
	message.hidden = true;
	field.closest('.gfield')?.append(message);

	let timer = null;
	let controller = null;

	// Increments per check so an aborted check's cleanup cannot switch the
	// spinner off underneath the check that superseded it.
	let sequence = 0;

	const check = async () => {
		const serial = field.value.trim();
		const run = ++sequence;

		if (controller) {
			controller.abort();
		}

		// Too short to be a serial; not worth a middleware round-trip yet.
		if (serial.length < 6) {
			wrapper.classList.remove('is-checking');
			message.hidden = true;
			return;
		}

		controller = new AbortController();
		wrapper.classList.add('is-checking');

		try {
			const response = await fetch('/my-true/check-serial', {
				method: 'POST',
				headers: { 'Content-Type': 'application/json' },
				body: JSON.stringify({ serial: serial }),
				signal: controller.signal,
			});

			const data = await response.json();

			// The field changed while this request was in flight.
			if (field.value.trim() !== serial) {
				return;
			}

			message.textContent = data.message ?? '';
			message.hidden = data.valid !== false;
		} catch (e) {
			// An abort means a newer check took over; anything else fails
			// silent -- the submit-time validation still enforces.
			if (e.name !== 'AbortError') {
				message.hidden = true;
			}
		} finally {
			if (run === sequence) {
				wrapper.classList.remove('is-checking');
			}
		}
	};

	field.addEventListener('input', () => {
		clearTimeout(timer);
		timer = setTimeout(check, 600);
	});

	// The field arrives prefilled from the MyTrue panel link, so check it
	// straight away rather than waiting for a keystroke.
	if (field.value.trim() !== '') {
		check();
	}
}
